module.exports = __webpack_public_path__ + "img/nextorbit-brand.871d3eb1.png";